/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Expand/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconArrowUp from 'DesignSystem/Svgs/TysiaIconArrowUp/index'



/** @type {import('Simple/types.js').View} */
export default function Expand({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/ExpandAction/Content/Expand"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaIconArrowUp
  viewPath={`${viewPath}/TysiaIconArrowUp`}
 fill={dtColorsNeutral400}
 height={14}
 width={14}
/>
{children}
</React.Fragment>)
}